/**
 * Do not edit directly
 * Generated on Mon, 07 Jul 2025 09:18:01 GMT
 */

export const DarkRadius = "0.5rem";
export const DarkFocus = "3px solid #4a5565";
export const DarkColorBackground = "#1e2939";
export const DarkColorAccent = "#2b7fff";
export const DarkColorAccentSubtle = "#155dfc";
export const DarkColorAccentStrong = "#8ec5ff";
export const DarkColorAccentWeak = "#1c398e";
export const DarkColorSuccess = "#00d5be";
export const DarkColorSuccessSubtle = "#009689";
export const DarkColorSuccessStrong = "#46ecd5";
export const DarkColorSuccessWeak = "#0b4f4a";
export const DarkColorNeutral = "#99a1af";
export const DarkColorNeutralSubtle = "#4a5565";
export const DarkColorNeutralStrong = "#d1d5dc";
export const DarkColorNeutralWeak = "#1e2939";
export const DarkColorCaution = "#fdc700";
export const DarkColorCautionSubtle = "#d08700";
export const DarkColorCautionStrong = "#ffdf20";
export const DarkColorCautionWeak = "#733e0a";
export const DarkColorWarning = "#ff8904";
export const DarkColorWarningSubtle = "#f54900";
export const DarkColorWarningStrong = "#ffb86a";
export const DarkColorWarningWeak = "#7e2a0c";
export const DarkColorDanger = "#ff6467";
export const DarkColorDangerSubtle = "#e7000b";
export const DarkColorDangerStrong = "#ffa2a2";
export const DarkColorDangerWeak = "#82181a";
export const DarkColorHighlight = "#7c86ff";
export const DarkColorHighlightSubtle = "#4f39f6";
export const DarkColorHighlightStrong = "#a3b3ff";
export const DarkColorHighlightWeak = "#312c85";
export const DarkColorText = "#f3f4f6";
export const DarkColorTextWeak = "#d1d5dc";
export const DarkColorTextWeaker = "#99a1af";
export const DarkColorTextWeakest = "#4a5565";
export const DarkColorTextLink = "#51a2ff";
export const DarkColorTextOnColor = "#000000";
export const DarkColorSurface = "#101828";
export const DarkColorSurfaceStrong = "#1e2939";
export const DarkColorSurfaceStronger = "#364153";
export const DarkColorSurfaceStrongest = "#4a5565";
export const DarkColorSurfaceHighlight = "#193cb8";
export const DarkColorSurfaceInverse = "#d1d5dc";
export const DarkColorBorder = "#364153";
export const DarkColorBorderStrong = "#4a5565";
export const LightRadius = "0.5rem";
export const LightFocus = "3px solid #f3f4f6";
export const LightColorBackground = "#f9fafb";
export const LightColorAccent = "#2b7fff";
export const LightColorAccentSubtle = "#8ec5ff";
export const LightColorAccentStrong = "#155dfc";
export const LightColorAccentWeak = "#eff6ff";
export const LightColorSuccess = "#00d5be";
export const LightColorSuccessSubtle = "#46ecd5";
export const LightColorSuccessStrong = "#009689";
export const LightColorSuccessWeak = "#f0fdfa";
export const LightColorNeutral = "#99a1af";
export const LightColorNeutralSubtle = "#d1d5dc";
export const LightColorNeutralStrong = "#4a5565";
export const LightColorNeutralWeak = "#f9fafb";
export const LightColorCaution = "#fdc700";
export const LightColorCautionSubtle = "#ffdf20";
export const LightColorCautionStrong = "#d08700";
export const LightColorCautionWeak = "#fefce8";
export const LightColorWarning = "#ff8904";
export const LightColorWarningSubtle = "#ffb86a";
export const LightColorWarningStrong = "#f54900";
export const LightColorWarningWeak = "#fff7ed";
export const LightColorDanger = "#ff6467";
export const LightColorDangerSubtle = "#ffa2a2";
export const LightColorDangerStrong = "#e7000b";
export const LightColorDangerWeak = "#fef2f2";
export const LightColorHighlight = "#7c86ff";
export const LightColorHighlightSubtle = "#c6d2ff";
export const LightColorHighlightStrong = "#4f39f6";
export const LightColorHighlightWeak = "#eef2ff";
export const LightColorText = "#364153";
export const LightColorTextWeak = "#6a7282";
export const LightColorTextWeaker = "#99a1af";
export const LightColorTextWeakest = "#d1d5dc";
export const LightColorTextLink = "#2b7fff";
export const LightColorTextOnColor = "#ffffff";
export const LightColorSurface = "#ffffff";
export const LightColorSurfaceStrong = "#f9fafb";
export const LightColorSurfaceStronger = "#f3f4f6";
export const LightColorSurfaceStrongest = "#e5e7eb";
export const LightColorSurfaceHighlight = "#eff6ff";
export const LightColorSurfaceInverse = "#364153";
export const LightColorBorder = "#e5e7eb";
export const LightColorBorderStrong = "#d1d5dc";
export const BlurXs = "4px";
export const BlurSm = "8px";
export const BlurMd = "12px";
export const BlurLg = "16px";
export const BlurXl = "24px";
export const BlurXxl = "40px";
export const BlurXxxl = "64px";
export const BreakpointBase = "0em";
export const BreakpointSm = "30em";
export const BreakpointMd = "48em";
export const BreakpointLg = "62em";
export const BreakpointXl = "80em";
export const BreakpointXxl = "96em";
export const ColorBlack = "#000000";
export const ColorWhite = "#ffffff";
export const ColorOverlay = "#00000066";
export const ColorAccent50 = "#eff6ff";
export const ColorAccent100 = "#dbeafe";
export const ColorAccent200 = "#bedbff";
export const ColorAccent300 = "#8ec5ff";
export const ColorAccent400 = "#51a2ff";
export const ColorAccent500 = "#2b7fff";
export const ColorAccent600 = "#155dfc";
export const ColorAccent700 = "#1447e6";
export const ColorAccent800 = "#193cb8";
export const ColorAccent900 = "#1c398e";
export const ColorAccent950 = "#162456";
export const ColorBase50 = "#f9fafb";
export const ColorBase100 = "#f3f4f6";
export const ColorBase200 = "#e5e7eb";
export const ColorBase300 = "#d1d5dc";
export const ColorBase400 = "#99a1af";
export const ColorBase500 = "#6a7282";
export const ColorBase600 = "#4a5565";
export const ColorBase700 = "#364153";
export const ColorBase800 = "#1e2939";
export const ColorBase900 = "#101828";
export const ColorBase950 = "#030712";
export const ColorRed50 = "#fef2f2";
export const ColorRed100 = "#ffe2e2";
export const ColorRed200 = "#ffc9c9";
export const ColorRed300 = "#ffa2a2";
export const ColorRed400 = "#ff6467";
export const ColorRed500 = "#fb2c36";
export const ColorRed600 = "#e7000b";
export const ColorRed700 = "#c10007";
export const ColorRed800 = "#9f0712";
export const ColorRed900 = "#82181a";
export const ColorRed950 = "#460809";
export const ColorOrange50 = "#fff7ed";
export const ColorOrange100 = "#ffedd4";
export const ColorOrange200 = "#ffd6a7";
export const ColorOrange300 = "#ffb86a";
export const ColorOrange400 = "#ff8904";
export const ColorOrange500 = "#ff6900";
export const ColorOrange600 = "#f54900";
export const ColorOrange700 = "#ca3500";
export const ColorOrange800 = "#9f2d00";
export const ColorOrange900 = "#7e2a0c";
export const ColorOrange950 = "#441306";
export const ColorAmber50 = "#fffbeb";
export const ColorAmber100 = "#fef3c6";
export const ColorAmber200 = "#fee685";
export const ColorAmber300 = "#ffd230";
export const ColorAmber400 = "#ffb900";
export const ColorAmber500 = "#fe9a00";
export const ColorAmber600 = "#e17100";
export const ColorAmber700 = "#bb4d00";
export const ColorAmber800 = "#973c00";
export const ColorAmber900 = "#7b3306";
export const ColorAmber950 = "#461901";
export const ColorYellow50 = "#fefce8";
export const ColorYellow100 = "#fef9c2";
export const ColorYellow200 = "#fff085";
export const ColorYellow300 = "#ffdf20";
export const ColorYellow400 = "#fdc700";
export const ColorYellow500 = "#f0b100";
export const ColorYellow600 = "#d08700";
export const ColorYellow700 = "#a65f00";
export const ColorYellow800 = "#894b00";
export const ColorYellow900 = "#733e0a";
export const ColorYellow950 = "#432004";
export const ColorLime50 = "#f7fee7";
export const ColorLime100 = "#ecfcca";
export const ColorLime200 = "#d8f999";
export const ColorLime300 = "#bbf451";
export const ColorLime400 = "#9ae600";
export const ColorLime500 = "#7ccf00";
export const ColorLime600 = "#5ea500";
export const ColorLime700 = "#497d00";
export const ColorLime800 = "#3c6300";
export const ColorLime900 = "#35530e";
export const ColorLime950 = "#192e03";
export const ColorGreen50 = "#f0fdf4";
export const ColorGreen100 = "#dcfce7";
export const ColorGreen200 = "#b9f8cf";
export const ColorGreen300 = "#7bf1a8";
export const ColorGreen400 = "#05df72";
export const ColorGreen500 = "#00c950";
export const ColorGreen600 = "#00a63e";
export const ColorGreen700 = "#008236";
export const ColorGreen800 = "#016630";
export const ColorGreen900 = "#0d542b";
export const ColorGreen950 = "#032e15";
export const ColorEmerald50 = "#ecfdf5";
export const ColorEmerald100 = "#d0fae5";
export const ColorEmerald200 = "#a4f4cf";
export const ColorEmerald300 = "#5ee9b5";
export const ColorEmerald400 = "#00d492";
export const ColorEmerald500 = "#00bc7d";
export const ColorEmerald600 = "#009966";
export const ColorEmerald700 = "#007a55";
export const ColorEmerald800 = "#006045";
export const ColorEmerald900 = "#004f3b";
export const ColorEmerald950 = "#002c22";
export const ColorTeal50 = "#f0fdfa";
export const ColorTeal100 = "#cbfbf1";
export const ColorTeal200 = "#96f7e4";
export const ColorTeal300 = "#46ecd5";
export const ColorTeal400 = "#00d5be";
export const ColorTeal500 = "#00bba7";
export const ColorTeal600 = "#009689";
export const ColorTeal700 = "#00786f";
export const ColorTeal800 = "#005f5a";
export const ColorTeal900 = "#0b4f4a";
export const ColorTeal950 = "#022f2e";
export const ColorCyan50 = "#ecfeff";
export const ColorCyan100 = "#cefafe";
export const ColorCyan200 = "#a2f4fd";
export const ColorCyan300 = "#53eafd";
export const ColorCyan400 = "#00d3f2";
export const ColorCyan500 = "#00b8db";
export const ColorCyan600 = "#0092b8";
export const ColorCyan700 = "#007595";
export const ColorCyan800 = "#005f78";
export const ColorCyan900 = "#104e64";
export const ColorCyan950 = "#053345";
export const ColorSky50 = "#f0f9ff";
export const ColorSky100 = "#dff2fe";
export const ColorSky200 = "#b8e6fe";
export const ColorSky300 = "#74d4ff";
export const ColorSky400 = "#00bcff";
export const ColorSky500 = "#00a6f4";
export const ColorSky600 = "#0084d1";
export const ColorSky700 = "#0069a8";
export const ColorSky800 = "#00598a";
export const ColorSky900 = "#024a70";
export const ColorSky950 = "#052f4a";
export const ColorBlue50 = "#eff6ff";
export const ColorBlue100 = "#dbeafe";
export const ColorBlue200 = "#bedbff";
export const ColorBlue300 = "#8ec5ff";
export const ColorBlue400 = "#51a2ff";
export const ColorBlue500 = "#2b7fff";
export const ColorBlue600 = "#155dfc";
export const ColorBlue700 = "#1447e6";
export const ColorBlue800 = "#193cb8";
export const ColorBlue900 = "#1c398e";
export const ColorBlue950 = "#162456";
export const ColorIndigo50 = "#eef2ff";
export const ColorIndigo100 = "#e0e7ff";
export const ColorIndigo200 = "#c6d2ff";
export const ColorIndigo300 = "#a3b3ff";
export const ColorIndigo400 = "#7c86ff";
export const ColorIndigo500 = "#615fff";
export const ColorIndigo600 = "#4f39f6";
export const ColorIndigo700 = "#432dd7";
export const ColorIndigo800 = "#372aac";
export const ColorIndigo900 = "#312c85";
export const ColorIndigo950 = "#1e1a4d";
export const ColorViolet50 = "#f5f3ff";
export const ColorViolet100 = "#ede9fe";
export const ColorViolet200 = "#ddd6ff";
export const ColorViolet300 = "#c4b4ff";
export const ColorViolet400 = "#a684ff";
export const ColorViolet500 = "#8e51ff";
export const ColorViolet600 = "#7f22fe";
export const ColorViolet700 = "#7008e7";
export const ColorViolet800 = "#5d0ec0";
export const ColorViolet900 = "#4d179a";
export const ColorViolet950 = "#2f0d68";
export const ColorPurple50 = "#faf5ff";
export const ColorPurple100 = "#f3e8ff";
export const ColorPurple200 = "#e9d4ff";
export const ColorPurple300 = "#dab2ff";
export const ColorPurple400 = "#c27aff";
export const ColorPurple500 = "#ad46ff";
export const ColorPurple600 = "#9810fa";
export const ColorPurple700 = "#8200db";
export const ColorPurple800 = "#6e11b0";
export const ColorPurple900 = "#59168b";
export const ColorPurple950 = "#3c0366";
export const ColorFuchsia50 = "#fdf4ff";
export const ColorFuchsia100 = "#fae8ff";
export const ColorFuchsia200 = "#f6cfff";
export const ColorFuchsia300 = "#f4a8ff";
export const ColorFuchsia400 = "#ed6aff";
export const ColorFuchsia500 = "#e12afb";
export const ColorFuchsia600 = "#c800de";
export const ColorFuchsia700 = "#a800b7";
export const ColorFuchsia800 = "#8a0194";
export const ColorFuchsia900 = "#721378";
export const ColorFuchsia950 = "#4b004f";
export const ColorPink50 = "#fdf2f8";
export const ColorPink100 = "#fce7f3";
export const ColorPink200 = "#fccee8";
export const ColorPink300 = "#fda5d5";
export const ColorPink400 = "#fb64b6";
export const ColorPink500 = "#f6339a";
export const ColorPink600 = "#e60076";
export const ColorPink700 = "#c6005c";
export const ColorPink800 = "#a3004c";
export const ColorPink900 = "#861043";
export const ColorPink950 = "#510424";
export const ColorRose50 = "#fff1f2";
export const ColorRose100 = "#ffe4e6";
export const ColorRose200 = "#ffccd3";
export const ColorRose300 = "#ffa1ad";
export const ColorRose400 = "#ff637e";
export const ColorRose500 = "#ff2056";
export const ColorRose600 = "#ec003f";
export const ColorRose700 = "#c70036";
export const ColorRose800 = "#a50036";
export const ColorRose900 = "#8b0836";
export const ColorRose950 = "#4d0218";
export const ColorSlate50 = "#f8fafc";
export const ColorSlate100 = "#f1f5f9";
export const ColorSlate200 = "#e2e8f0";
export const ColorSlate300 = "#cad5e2";
export const ColorSlate400 = "#90a1b9";
export const ColorSlate500 = "#62748e";
export const ColorSlate600 = "#45556c";
export const ColorSlate700 = "#314158";
export const ColorSlate800 = "#1d293d";
export const ColorSlate900 = "#0f172b";
export const ColorSlate950 = "#020618";
export const ColorGray50 = "#f9fafb";
export const ColorGray100 = "#f3f4f6";
export const ColorGray200 = "#e5e7eb";
export const ColorGray300 = "#d1d5dc";
export const ColorGray400 = "#99a1af";
export const ColorGray500 = "#6a7282";
export const ColorGray600 = "#4a5565";
export const ColorGray700 = "#364153";
export const ColorGray800 = "#1e2939";
export const ColorGray900 = "#101828";
export const ColorGray950 = "#030712";
export const ColorZinc50 = "#fafafa";
export const ColorZinc100 = "#f4f4f5";
export const ColorZinc200 = "#e4e4e7";
export const ColorZinc300 = "#d4d4d8";
export const ColorZinc400 = "#9f9fa9";
export const ColorZinc500 = "#71717b";
export const ColorZinc600 = "#52525c";
export const ColorZinc700 = "#3f3f46";
export const ColorZinc800 = "#27272a";
export const ColorZinc900 = "#18181b";
export const ColorZinc950 = "#09090b";
export const ColorNeutral50 = "#fafafa";
export const ColorNeutral100 = "#f5f5f5";
export const ColorNeutral200 = "#e5e5e5";
export const ColorNeutral300 = "#d4d4d4";
export const ColorNeutral400 = "#a1a1a1";
export const ColorNeutral500 = "#737373";
export const ColorNeutral600 = "#525252";
export const ColorNeutral700 = "#404040";
export const ColorNeutral800 = "#262626";
export const ColorNeutral900 = "#171717";
export const ColorNeutral950 = "#0a0a0a";
export const ColorStone50 = "#fafaf9";
export const ColorStone100 = "#f5f5f4";
export const ColorStone200 = "#e7e5e4";
export const ColorStone300 = "#d6d3d1";
export const ColorStone400 = "#a6a09b";
export const ColorStone500 = "#79716b";
export const ColorStone600 = "#57534d";
export const ColorStone700 = "#44403b";
export const ColorStone800 = "#292524";
export const ColorStone900 = "#1c1917";
export const ColorStone950 = "#0c0a09";
export const FontSizeXs = "0.6rem";
export const FontSizeSm = "0.8rem";
export const FontSizeMd = "1rem";
export const FontSizeLg = "1.25rem";
export const FontSizeXl = "1.5rem";
export const FontSize2xl = "1.75rem";
export const FontSize3xl = "2rem";
export const FontSizeLarge = "3rem";
export const FontSizeHuge = "5rem";
export const FontSizeJumbo = "6.75rem";
export const FontSizeKbd = "0.75rem";
export const FontWeightHairline = 100;
export const FontWeightThin = 200;
export const FontWeightLight = 300;
export const FontWeightNormal = 400;
export const FontWeightMedium = 500;
export const FontWeightSemibold = 600;
export const FontWeightBold = 700;
export const FontWeightExtrabold = 800;
export const FontWeightBlack = 900;
export const FontHeading = "Inter,-apple-system,system-ui,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif";
export const FontBody = "Inter,-apple-system,system-ui,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif";
export const FontMono = "SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace";
export const IconSizeXs = "0.8rem";
export const IconSizeSm = "1rem";
export const IconSizeMd = "1.3rem";
export const IconSizeLg = "1.6rem";
export const IconSizeXl = "2.1rem";
export const IndexHide = -1;
export const IndexAuto = "auto";
export const IndexBase = 0;
export const IndexDocked = 10;
export const IndexSwipable = 800;
export const IndexResizable = 900;
export const IndexDropdown = 1000;
export const IndexSticky = 1100;
export const IndexBanner = 1200;
export const IndexOverlay = 1300;
export const IndexMenu = 1400;
export const IndexModal = 1400;
export const IndexPopover = 1400;
export const IndexToast = 1700;
export const IndexTooltip = 1800;
export const IndexAffix = 2000;
export const IndexSkipNav = 2100;
export const LetterSpacingTighter = "-0.05em";
export const LetterSpacingTight = "-0.025em";
export const LetterSpacingNormal = "0";
export const LetterSpacingWide = "0.025em";
export const LetterSpacingWider = "0.05em";
export const LetterSpacingWidest = "0.1em";
export const LineHeightNormal = "normal";
export const LineHeightNone = "1rem";
export const LineHeightShorter = "1.25rem";
export const LineHeightShort = "1.375rem";
export const LineHeightBase = "1.5rem";
export const LineHeightTall = "1.625rem";
export const LineHeightTaller = "2rem";
export const RadiusXs = "0.125rem";
export const RadiusSm = "0.25rem";
export const RadiusMd = "0.375rem";
export const RadiusLg = "0.5rem";
export const RadiusXl = "0.75rem";
export const Radius2xl = "1rem";
export const Radius3xl = "1.5rem";
export const RadiusFull = "9999px";
export const RadiusRound = "50%";
export const RadiusDefault = "0.5rem";
export const ShadowFlat = "0 1px 3px rgba(12, 12, 12, 0.09)";
export const ShadowXs = "0 0 0 1px rgba(0, 0, 0, 0.05)";
export const ShadowSm = "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
export const ShadowBase = "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)";
export const ShadowMd = "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
export const ShadowLg = "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)";
export const ShadowXl = "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)";
export const Shadow2xl = "0 25px 50px -12px rgba(0, 0, 0, 0.25)";
export const ShadowCard = "0 20px 25px -5px rgba(0, 0, 0, 0.04)";
export const ShadowMenu = "0 20px 25px -5px rgba(0, 0, 0, 0.04)";
export const ShadowOutline = "0 0 0 3px rgba(66, 153, 225, 0.6)";
export const ShadowInner = "inset 0 2px 4px 0 rgba(0,0,0,0.06)";
export const ShadowInnerInner = "inset 0 10px 40px 0 rgba(0,0,0,1)";
export const ShadowNone = "none";
export const ShadowDarkL = "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px";
export const Size0 = "0.125rem";
export const Size1 = "0.25rem";
export const Size2 = "0.5rem";
export const Size3 = "0.75rem";
export const Size4 = "1rem";
export const Size5 = "1.25rem";
export const Size6 = "1.5rem";
export const Size7 = "1.75rem";
export const Size8 = "2rem";
export const Size9 = "2.25rem";
export const Size10 = "2.5rem";
export const Size11 = "2.75rem";
export const Size12 = "3rem";
export const Size13 = "3.25rem";
export const Size14 = "3.5rem";
export const Size15 = "3.75rem";
export const Size16 = "4rem";
export const Size17 = "4.25rem";
export const Size18 = "4.5rem";
export const Size19 = "4.75rem";
export const Size20 = "5rem";
export const Size24 = "6rem";
export const Size28 = "7rem";
export const Size32 = "8rem";
export const Size36 = "9rem";
export const Size40 = "10rem";
export const Size44 = "11rem";
export const Size48 = "12rem";
export const Size52 = "13rem";
export const Size56 = "14rem";
export const Size60 = "15rem";
export const Size64 = "16rem";
export const Size72 = "18rem";
export const Size80 = "20rem";
export const Size96 = "24rem";
export const Size100 = "100%";
export const Space0 = "0.125rem";
export const Space1 = "0.25rem";
export const Space2 = "0.5rem";
export const Space3 = "0.75rem";
export const Space4 = "1rem";
export const Space5 = "1.25rem";
export const Space6 = "1.5rem";
export const Space7 = "1.75rem";
export const Space8 = "2rem";
export const Space9 = "2.25rem";
export const Space10 = "2.5rem";
export const Space11 = "2.75rem";
export const Space12 = "3rem";
export const Space13 = "3.25rem";
export const Space14 = "3.5rem";
export const Space16 = "4rem";
export const Space20 = "5rem";
export const Space24 = "6rem";
export const Space28 = "7rem";
export const Space32 = "8rem";
export const Space36 = "9rem";
export const Space40 = "10rem";
export const Space44 = "11rem";
export const Space48 = "12rem";
export const Space52 = "13rem";
export const Space56 = "14rem";
export const Space60 = "15rem";
export const Space64 = "16rem";
export const Space72 = "18rem";
export const Space80 = "20rem";
export const Space96 = "24rem";
export const SpaceInsetX1 = "0.2rem 0.5rem";
export const SpaceInsetX2 = "0.5rem 0.9rem";
export const SpaceInsetX3 = "0.6rem 1.2rem";
export const SpaceInsetX4 = "0.8rem 1.6rem";
export const SpaceInsetX5 = "1.2rem 2.4rem";
export const SpaceInsetX6 = "1.6rem 3.2rem";
export const SpaceInsetX7 = "2.4rem 4.8rem";
export const SpaceInsetY1 = "0.5rem 0.2rem";
export const SpaceInsetY2 = "0.7rem 0.5rem";
export const SpaceInsetY3 = "1.2rem 0.8rem";
export const SpaceInsetY4 = "1.8rem 1.2rem";
export const SpaceInsetY5 = "2.4rem 1.6rem";
export const SpaceInsetY6 = "3.6rem 2.4rem";
export const SpaceInsetY7 = "4.8rem 3.2rem";
export const TransitionPropertyCommon = "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform";
export const TransitionPropertyColors = "background-color, border-color, color, fill, stroke";
export const TransitionPropertyDimensions = "width, height";
export const TransitionPropertyPosition = "left, right, top, bottom";
export const TransitionPropertyBackground = "background-color, background-image, background-position";
export const TransitionEasingEaseIn = "cubic-bezier(0.4, 0, 1, 1)";
export const TransitionEasingEaseOut = "cubic-bezier(0, 0, 0.2, 1)";
export const TransitionEasingEaseInOut = "cubic-bezier(0.4, 0, 0.2, 1)";
export const TransitionDurationUltraFast = "50ms";
export const TransitionDurationFaster = "100ms";
export const TransitionDurationFast = "150ms";
export const TransitionDurationNormal = "200ms";
export const TransitionDurationSlow = "300ms";
export const TransitionDurationSlower = "400ms";
export const TransitionDurationUltraSlow = "500ms";
